// import React, { useState } from 'react';
// import { FaTimes, FaExclamationCircle } from 'react-icons/fa';

// const CreateFolderModal = ({ isOpen, onClose, onCreate, token }) => {
//   const [folderName, setFolderName] = useState('');
//   const [isLoading, setIsLoading] = useState(false);

//   if (!isOpen) {
//     return null;
//   }

//   const handleSubmit = async () => {
//     if (folderName.trim()) {
//       setIsLoading(true);
//       try {
//         await onCreate(folderName.trim());
//         setFolderName('');
//       } catch (error) {
//         // Error handling is done in parent component
//         console.error('Error in handleSubmit:', error);
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   const handleClose = () => {
//     setFolderName('');
//     onClose();
//   };

//   const isCreateDisabled = folderName.trim() === '' || isLoading;

//   return (
//     <div 
//       className="fixed inset-0 bg-black/40 flex items-center justify-center z-[1000] font-sans"
//       onClick={handleClose}
//     >
//       <div 
//         className="bg-white p-4 rounded-xl shadow-xl w-full max-w-[450px]"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Modal Header */}
//         <div className="flex justify-between items-center mb-5">
//           <p className="text-[#171717] font-outfit text-lg font-semibold leading-none">Create New Folder</p>
//           <button 
//             onClick={handleClose} 
//             className="bg-transparent border-none text-lg text-gray-500 cursor-pointer p-1 leading-none"
//             disabled={isLoading}
//           >
//             <FaTimes />
//           </button>
//         </div>
        
//         {/* Modal Body */}
//         <div className="">
          
//           <div className="form-group mb-4">
//             <label 
//               htmlFor="folderName" 
//               className="!text-[#3F3F46] font-outfit text-sm !font-semibold leading-none mb-2 block"
//             >
//               Folder Name *
//             </label>
//             <input
//               type="text"
//               id="folderName"
//               className="w-full px-[14px] py-2.5 text-sm !font-normal border border-gray-300 rounded-lg placeholder:text-gray-400 
//                          hover:border-gray-400 
//                          focus:border-[#A871EC] focus:outline-none focus:ring-2 focus:ring-[#A871EC]/20
//                          transition-colors min-h-[42px] box-border"
//               placeholder="Enter Folder Name"
//               value={folderName}
//               onChange={(e) => setFolderName(e.target.value)}
//               autoFocus
//               disabled={isLoading}
//             />
//           </div>
          
         
//         </div>
        
//         {/* Modal Footer */}
//         <div className="flex justify-center gap-3 mt-6">
//           <button 
//             onClick={handleClose} 
//             className="py-2 px-5 text-sm font-semibold rounded-lg border border-[#C95EBE] !text-[#C95EBE] bg-white  "
//             disabled={isLoading}
//           >
//             Cancel
//           </button>
//           <button 
//             onClick={handleSubmit} 
//             className="py-2 px-5 text-sm font-semibold rounded-lg border border-[#C95EBE] bg-[#C95EBE] text-white transition-colors
//                        disabled:bg-[#BB42AE · 36%] disabled:opacity-60 disabled:cursor-not-allowed"
//             disabled={isCreateDisabled}
//           >
//             {isLoading ? "Creating..." : "Create Folder"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CreateFolderModal;
import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';

const CreateFolderModal = ({ isOpen, onClose, onCreate, token }) => {
  const [folderName, setFolderName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isCreated, setIsCreated] = useState(false);

  if (!isOpen) {
    return null;
  }

  const handleSubmit = async () => {
    if (folderName.trim()) {
      setIsLoading(true);
      try {
        await onCreate(folderName.trim());
        setIsCreated(true);
        setTimeout(() => {
          setFolderName('');
          setIsCreated(false);
          setIsLoading(false);
          onClose();
        }, 2000); // closes popup after 2 seconds
      } catch (error) {
        setIsLoading(false);
        // Error handling is done in parent
      }
    }
  };

  const handleClose = () => {
    setFolderName('');
    setIsCreated(false);
    setIsLoading(false);
    onClose();
  };

  const isCreateDisabled = folderName.trim() === '' || isLoading || isCreated;

  return (
    <div 
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999] font-sans"
      onClick={handleClose}
    >
      <div 
        className="bg-white p-4 rounded-xl shadow-xl w-full max-w-[450px] relative z-[10000]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-5">
          <p className="text-[#171717] font-outfit text-lg font-semibold leading-none">Create New Folder</p>
          <button 
            onClick={handleClose} 
            className="bg-transparent border-none text-lg text-gray-500 cursor-pointer p-1 leading-none"
            disabled={isLoading}
          >
            <FaTimes />
          </button>
        </div>
        
        {/* Modal Body */}
        <div className="">
          <div className="form-group mb-4">
            <label 
              htmlFor="folderName" 
              className="!text-[#3F3F46] font-outfit text-sm !font-semibold leading-none mb-2 block"
            >
              Folder Name *
            </label>
            <input
              type="text"
              id="folderName"
              className="w-full px-[14px] py-2.5 text-sm !font-normal border border-gray-300 rounded-lg placeholder:text-gray-400 
                         hover:border-gray-400 
                         focus:border-[#A871EC] focus:outline-none focus:ring-2 focus:ring-[#A871EC]/20
                         transition-colors min-h-[42px] box-border"
              placeholder="Enter Folder Name"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              autoFocus
              disabled={isLoading || isCreated}
            />
          </div>
        </div>
        
        {/* Modal Footer */}
        <div className="flex justify-center gap-3 mt-6">
          <button 
            onClick={handleClose} 
            className="py-2 w-[20%] text-sm font-semibold rounded-lg border border-[#C95EBE] !text-[#C95EBE] bg-white"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button 
            onClick={isCreated ? null : handleSubmit} 
            className="py-2 w-[30%] text-sm font-semibold rounded-lg border border-[#C95EBE] bg-[#C95EBE] !text-white transition-colors
                       disabled:bg-[#BB42AE · 36%] disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={isCreateDisabled}
          >
            {isCreated ? "Created" : (isLoading ? "Creating..." : "Create Folder")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateFolderModal;
